import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/ticket.styles'
import clsx from 'clsx'
import { useMediaQuery } from '@material-ui/core'
import leftArrow from './assets/images/leftArrow.svg'

const useStyles = makeStyles(styles)

export default function SwiperTicket2({
	name,
	open,
	src,
	primaryText,
	index,
	secondaryText,
	bigContent,
	handleClick,
	}) {
	const props = { open }
	const isMobile = useMediaQuery('(max-width: 1230px)')
	const isMore = bigContent != ''
	const classes = useStyles(props)
	return (
		<span className={clsx(classes.span, open && classes.boxShadow)}>
			<div className={clsx(classes.root, open && classes.expanded)} >
				<span className={classes.textWrap} >
					<p className={classes.name} >{name}</p>
					<p className={classes.content} ><strong>{primaryText}</strong>/{secondaryText}</p>
					{isMore &&
						<p className={classes.content} ><strong>{primaryText}</strong>/{bigContent}</p>
					}
				</span>
			</div>
		</span>
	)
}